import { MdQuestionAnswer } from 'react-icons/md';
import type { SATheme } from '../../types/stylingAssistant.types';

interface SAFollowUpQuestionsProps {
  theme: SATheme;
  questions: string[];
  onQuestionClick: (question: string) => void;
}

export default function SAFollowUpQuestions({
  theme,
  questions,
  onQuestionClick,
}: SAFollowUpQuestionsProps) {
  if (!questions || questions.length === 0) return null;

  return (
    <div className="space-y-2 animate-fadeIn">
      <p
        className="text-[10px] font-semibold tracking-widest uppercase px-1"
        style={{ color: theme.textMuted }}
      >
        Suggested follow-ups
      </p>
      <div className="flex flex-wrap gap-2">
        {questions.map((question, idx) => (
          <button
            key={idx}
            onClick={() => onQuestionClick(question)}
            className="group flex items-center gap-2 px-3.5 py-2 rounded-xl text-sm transition-all duration-200 hover:scale-[1.02] cursor-pointer"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.04)',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              color: theme.text,
            }}
          >
            <MdQuestionAnswer
              size={14}
              className="flex-shrink-0 text-gray-500 group-hover:text-[#EE4423] transition-colors"
            />
            <span className="text-left leading-snug text-xs">{question}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
